import React from "react";
import { formatUSPhone } from "../lib/format";

export function PhoneInput({ value, onChange, testId, placeholder, className }) {
  return (
    <div className={`flex items-stretch ${className || ""}`}>
      <span className="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-slate-300 bg-slate-50 text-slate-600 text-sm font-medium select-none">
        +1
      </span>
      <input
        data-testid={testId}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        placeholder={placeholder || "(555) 123-4567"}
        value={value || ""}
        onChange={(e) => onChange(formatUSPhone(e.target.value))}
        className="cm-input rounded-l-none flex-1 min-w-0"
      />
    </div>
  );
}
